// FileInputWithPreview.js
import React, { useState } from "react";
import { Box, Button, Typography } from "@material-ui/core";
import { useFormContext } from "react-hook-form";

const FileInputWithPreview = (props) => {
  const { catalogo, infoFolder } = props;
  const {
    register,
    setValue,
    formState: { errors },
  } = useFormContext(); // Añadido formState para errores
  const [file, setFile] = useState(null); // Aseguramos que la variable se llama "file"
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile); // Guardamos el archivo en el estado
      setValue("file", selectedFile); // Actualiza el valor en react-hook-form
      const fileUrl = URL.createObjectURL(selectedFile);
      setPreviewUrl(fileUrl);
    }
  };

  const handleClearPreview = () => {
    setFile(null); // Limpia el archivo del estado
    setValue("file", null); // Limpia el valor en react-hook-form
    setPreviewUrl(null);
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
      <input
        type="file"
        accept="image/*,.pdf"
        onChange={handleFileChange}
        style={{ display: "none" }}
        id="file-input"
        {...register("file", { required: "El archivo es obligatorio" })} // Validación de campo obligatorio
      />
      <label htmlFor="file-input">
        <Button variant="contained" color="primary" component="span">
          Seleccionar archivo *
        </Button>
      </label>

      {errors.file && ( // Mostrar mensaje de error si el archivo es obligatorio y no se ha seleccionado
        <Typography variant="body2" color="error">
          {errors.file.message}
        </Typography>
      )}

      {file && ( // Cambiado "selectedFile" por "file"
        <>
          <Typography variant="body1">
            Archivo seleccionado: {file.name}
          </Typography>
          {file.type.startsWith("image/") ? (
            <img
              src={previewUrl}
              alt="Vista previa"
              style={{ width: "100%", maxHeight: "400px", marginTop: "10px" }}
            />
          ) : (
            <iframe
              src={previewUrl}
              title="Vista previa de PDF"
              style={{ width: "100%", height: "400px", marginTop: "10px" }}
            />
          )}
          <Button
            variant="contained"
            color="secondary"
            onClick={handleClearPreview}
            style={{ marginTop: "10px" }}
          >
            Limpiar selección
          </Button>
        </>
      )}
    </Box>
  );
};

export default FileInputWithPreview;
